import React from "react";
import TooltipV2 from "@ui/TooltipV2";
import type { Project } from "../../../api/useProjects";

import t from "../../../i18n";
import OverlayWrapper from "@ui/TooltipV2/OverlayWrapper";
import Link from "@ui/Link";
import { css } from "@linaria/core";
import { color, fonts } from "@ui";
import { AlertFilterLine } from "@ui/IconV2/react";
import { isActiveAnalysis } from "../../../api/useActiveAnalysesStream";
import type { Analysis } from "../../../api/Analysis";
import { analysisCompliance } from "diagnostics-domain/quantity/compliance";
import type { Quantity } from "../../../api/useQuantities";
import { toPath } from "../../../router/helpers/path";

const AnalysisFilterCompliant = ({
  project,
  quantities,
  analysis,
}: {
  project: Project;
  quantities: Quantity[];
  analysis: Analysis;
}) => {
  const { compliant, compliance } = analysis
    ? analysisCompliance(quantities, analysis)
    : { compliant: false, compliance: {} };

  if (compliant) return null;

  return (
    <TooltipV2
      placement="right"
      overlay={
        <OverlayWrapper
          text={t(
            "commons.tooltip.warning.selected_analysis_not_filter_compliant_with_details",
            compliance,
            <Link
              className={styledLink}
              to={toPath("/projects/:projectId/settings/filters", {
                projectId: project.id,
              })}
            >
              {t(
                "commons.tooltip.warning.selected_analysis_not_filter_compliant.view_activation_filters",
              )}
            </Link>,
            isActiveAnalysis(analysis),
          )}
        />
      }
    >
      <div className={centerIcon}>
        <AlertFilterLine size="m" />
      </div>
    </TooltipV2>
  );
};

export default AnalysisFilterCompliant;

//#region CSS
const styledLink = css`
  font: ${fonts.body2};
  color: ${color.lightNitrogen500_Main};
  :hover {
    text-decoration: underline;
    color: ${color.lightNitrogen600};
  }
`;
const centerIcon = css`
  display: grid;
  place-items: center;
`;
//#endregion CSS
